import { Image } from "@chakra-ui/react";

export const getMaker = (data) => {
  switch (data) {
    case "digikey":
      return "디지키";
    case "mouser":
      return "마우저";
    case "arrow":
      return "애로우";
    case "verical":
      return "베리칼";
    case "onechip":
      return "원칩";
    case "dfrobot":
      return "디에프로봇";
    case "seeed":
      return "씨드";
    case "alliance":
      return "판다파츠";
  }
};

export const logo = (data) => {
  let logo_url = "";
  switch (data.it_maker) {
    case "mouser":
      logo_url = "/images/brand/mouser.png";
      break;
    case "digikey":
      logo_url = "/images/brand/dk_real_logo.png";
      break;
    case "arrow":
      logo_url = "/images/brand/arrow.png";
      break;
    case "verical":
      logo_url = "/images/brand/veri.png";
      break;
    case "onechip":
      logo_url = "/images/brand/one.png";
      break;
    case "dfrobot":
      logo_url = "/images/brand/df.png";
      break;
    case "seeed":
      logo_url = "/images/brand/see.png";
      break;
    case "pandaparts":
      logo_url = "/images/brand/panda.png";
      break;
    case "future":
      logo_url = "/images/brand/alliance.png";
      break;
    case "corestaff":
      logo_url = "/images/brand/alliance.png";
      break;
    case "pei":
      logo_url = "/images/brand/alliance.png";
      break;
    case "partner":
      logo_url = "/images/brand/partner.png";
    default:
      logo_url = "/images/no_img.png";
      break;
  }
  return <Image width="70px" src={logo_url} />;
};
